import { DatadogRumConfig } from '@thyme/libs/src/datadog/config'
import { FeatureFlagProviderConfig } from '@thyme/libs/src/flags/types'
import { MeiliSearchConfig } from '@thyme/libs/src/meiliSearch/config'
import { StrapiConfig } from '@thyme/libs/src/strapi/config'
import { envSchema } from '@/envSchema'
import type { InjectionKey } from 'vue'
import type { z } from 'zod'

// Derived from the schema so the env list has one source of truth: adding an
// env to `VITE_ENV` widens this automatically
export type ConnectEnv = z.infer<typeof envSchema.VITE_ENV>

export interface Auth0Config {
  domain: string
  clientId: string
  audience: string
  enablePasswordAuth: boolean
}

export interface Config {
  env: ConnectEnv
  apiUrl: string
  auth0: Auth0Config
  flags: FeatureFlagProviderConfig
  datadog: {
    // if true, enables Datadog RUM and Logs
    enabled: boolean
  } & DatadogRumConfig
  strapi: StrapiConfig
  meiliSearch: MeiliSearchConfig
  eventService: {
    url: string
    apiKey: string
  }
}

// https://vuejs.org/guide/typescript/composition-api#typing-provide-inject
export const APP_CONFIG_KEY = Symbol('APP_CONFIG_KEY') as InjectionKey<Config>
